import React from "react"
import {
	Box,
	Button,
	Checkbox,
	FormControl,
	FormControlLabel,
	makeStyles,
	TextField,
	Typography
} from "@material-ui/core"

import { makeMessages } from "../../utils/makeMessages";
import { GdprAnchor } from "../Gdpr"



export interface ContactFormProps {

}


export const ContactForm = (props: ContactFormProps) => {
	const classes = useStyles();
	const msgs = useMessages();
	return (
		<form method="post" action="/api/contact">
			<input type="hidden" name="next" value={msgs.next} />

			<TextField
				name="name"
				required

				label={msgs.name}
				variant="outlined"
				margin="normal"
				fullWidth
			/>

			<TextField
				name="email"
				required

				label="E-mail"
				type="email"
				variant="outlined"
				margin="normal"
				fullWidth
			/>
			
			<TextField
				name="web"
				
				label="Web"
				type="text"
				variant="outlined"
				margin="normal"
				fullWidth
				autoComplete="off"
				tabIndex={-1}
				className={classes.honeypot}
			/>

			<TextField
				name="fax"
				
				label="Fax"
				type="tel"
				variant="outlined"
				margin="normal"
				fullWidth
				autoComplete="off"
				tabIndex={-1}
				className={classes.honeypot}
			/>

			<TextField
				name="subject"
				required

				label={msgs.subject}
				variant="outlined"
				margin="normal"
				fullWidth
			/>

			<TextField
				name="message"
				required

				label={msgs.message}
				variant="outlined"
				multiline
				margin="normal"
				rows={5}
				rowsMax={20}
				fullWidth
			/>

			<FormControlLabel
				value=""
				control={(
					<Checkbox name="gdpr_agreement" value="1" color="primary" required />
				)}
				label={(
					<Typography variant="inherit">
						{msgs.gdprAgreement}
					</Typography>
				)}
				labelPlacement="end"
			/>
			
			<FormControl margin={"normal"} error={true} className={classes.honeypot}>
				<FormControlLabel
					control={(
						<Checkbox name="user_agreement" value="1" color="primary" tabIndex={-1} inputProps={{autoComplete: "off"}} />
					)}
					label={'Som Robot'}
					labelPlacement="end"
					tabIndex={-1}
				/>
			</FormControl>

			<Box marginTop={2}>
				<Button type="submit" variant="contained" color="primary" size="large">{msgs.submit}</Button>
			</Box>
		</form>
	);
};

const useStyles = makeStyles(theme => ({
	honeypot: {
		display: 'none',
	}
}));

const useMessages = makeMessages({
	name: {
		sk: 'Vaše meno',
		en: 'Your name',
	},
	subject: {
		sk: 'Predmet',
		en: 'Subject',
	},
	message: {
		sk: 'Správa',
		en: 'Message',
	},
	submit: {
		sk: 'Odoslať',
		en: 'Send',
	},
	gdprAgreement: {
		sk: <>{'súhlasím so '}<GdprAnchor>spracovaním osobných údajov na{'\u00A0'}kontaktné účely</GdprAnchor></>,
		en: <>I agree to the <GdprAnchor>processing of personal data for contact purposes</GdprAnchor></>,
	},
	next: {
		sk: '/kontakt/odoslany',
		en: '/en/contact-us/done',
	},
});
